import { Component, ContentChild, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';
import { BaseService } from 'src/app/tabms/services/base/base.service';

@Component({
  selector: 'app-base-create',
  templateUrl: './base-create.component.html',
  styleUrl: './base-create.component.scss'
})
export class BaseCreateComponent<T> implements OnInit, OnDestroy {
  //#region Input
  @Input() set service(_service) {
    if (!_service) return;
    this.serviceInstance = _service;
  }

  @Input() set fieldsConfigService(_fieldsConfigService) {
    if (!_fieldsConfigService) return;
    this.fieldsConfigServiceInstance = _fieldsConfigService;
  }

  @Input() canCreate:boolean =true;
  @Input() canEdit :boolean=true;
  //#endregion

  //#region public props
  serviceInstance;
  fieldsConfigServiceInstance;
  editId;
  headerClass = 'headerClass';
  title;
  //#endregion

  private destroy$: Subject<void> = new Subject<void>();

  constructor(private baseService: BaseService, private translate: TranslateService) {
    this.translate.instant('create');
  }

  ngOnInit() {
    this.baseService.createFormDisplay.pipe(takeUntil(this.destroy$)).subscribe((res) => {
      this.editId = res?.id;
      if (this.editId)
        this.title = this.translate.instant('edit');
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}


